import { NexusRoutes } from '../routes';
import { BaseAPIClient } from './BaseAPIClient';
import {
  FetchEcosystemOverviewSummaryRequest,
  FetchEcosystemOverviewSummaryResponse,
  FetchGromaCoinOverviewRequest,
  FetchGromaCoinOverviewResponse,
  FetchPropertiesRequest,
  FetchPropertiesResponse,
  FetchPropertyFinancialsRequest,
  FetchPropertyFinancialsResponse,
  FetchPropertyRequest,
  FetchPropertyResponse,
} from './APIClientInterface';

export class APIClient extends BaseAPIClient {
  static async getPropertyMetadata(url: string): Promise<any> {
    const { client, config } = this.createClient({}, { baseURL: '', withCredentials: false });

    return client
      .get(url, config)
      .then(httpResponse => httpResponse.data)
      .catch(console.log);
  }

  static async getProperties(request: FetchPropertiesRequest): Promise<FetchPropertiesResponse> {
    const { page_size, page } = request;
    const { client, config } = this.createClient();

    return client
      .get(`${NexusRoutes.Properties}?page=${page}&page_size=${page_size}`, config)
      .then(httpResponse => {
        const response = this.prepareResponse<FetchPropertiesResponse>(request, httpResponse);
        if (response.success) {
          response.properties = httpResponse.data.results;
          response.nextPageUrl = httpResponse.data.next;
        }
        return response;
      })
      .catch(err => {
        return this.prepareResponse<FetchPropertiesResponse>(request, err);
      });
  }

  static async getPropertyById(request: FetchPropertyRequest): Promise<FetchPropertyResponse> {
    const { id } = request;
    const { client, config } = this.createClient();

    return client
      .get(NexusRoutes.PropertyDetails(id), config)
      .then(httpResponse => {
        const response = this.prepareResponse<FetchPropertyResponse>(request, httpResponse);
        if (response.success) response.property = httpResponse.data;

        return response;
      })
      .catch(err => {
        return this.prepareResponse<FetchPropertyResponse>(request, err);
      });
  }

  static async getPropertyFinancials(
    request: FetchPropertyFinancialsRequest
  ): Promise<FetchPropertyFinancialsResponse> {
    const { id } = request;
    const { client, config } = this.createClient();

    return client
      .get(NexusRoutes.PropertyFinancials(id), config)
      .then(httpResponse => {
        const response = this.prepareResponse<FetchPropertyFinancialsResponse>(request, httpResponse);
        if (response.success) response.financials = httpResponse.data;

        return response;
      })
      .catch(err => {
        return this.prepareResponse<FetchPropertyFinancialsResponse>(request, err);
      });
  }

  static async getEcosystemOverviewSummary(
    request: FetchEcosystemOverviewSummaryRequest
  ): Promise<FetchEcosystemOverviewSummaryResponse> {
    const { client, config } = this.createClient();

    return client
      .get(NexusRoutes.EcosystemOverview, config)
      .then(httpResponse => {
        const response = this.prepareResponse<FetchEcosystemOverviewSummaryResponse>(request, httpResponse);
        if (response.success) response.summary = httpResponse.data;

        return response;
      })
      .catch(err => {
        return this.prepareResponse<FetchEcosystemOverviewSummaryResponse>(request, err);
      });
  }

  static async getGromaCoinOverview(request: FetchGromaCoinOverviewRequest): Promise<FetchGromaCoinOverviewResponse> {
    const { client, config } = this.createClient();

    return client
      .get(NexusRoutes.GromaCoinOverview, config)
      .then(httpResponse => {
        const response = this.prepareResponse<FetchGromaCoinOverviewResponse>(request, httpResponse);
        if (response.success) response.overview = httpResponse.data;

        return response;
      })
      .catch(err => {
        return this.prepareResponse<FetchGromaCoinOverviewResponse>(request, err);
      });
  }
}
